import ArgType, {withErrorsAllowed} from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';
import {EvaluablePrimitiveSpreadsheetFunction} from 'notebook/tables/excess/FunctionConstants';
import {Range} from 'notebook/tables/excess/FunctionConstants';
import * as util from 'notebook/tables/excess/Util';
import {TypedValue} from 'notebook/tables/TableConstants';
import {EvaluablePrimitive, coerceToPrimitive} from 'notebook/tables/typed-values/DataTypes';
import * as logging from 'util/Logging';

export default {
  name: 'IF',
  category: FunctionCategory.LOGIC,
  shortDescription: 'Returns value depending on logical expression.',
  description: 'Returns one value if a logical expression is TRUE and another if it is FALSE.',
  params: [
    {
      name: 'logical_test',
      // TODO(BNCH-114118): Make this ArgType.any and coerce to boolean
      type: ArgType.boolean,
      description:
        'An expression or reference to a cell containing an expression that represents some logical value, i.e. TRUE or FALSE.',
    },
    {
      name: 'value_if_true',
      // TODO: make this withErrorsAllowed(ArgType.singularValue)
      type: withErrorsAllowed(ArgType.any),
      description: 'The value the function returns if logical_expression is TRUE.',
      // Do not coerce numeric-like arguments to numbers
      coerce: (typedValue: TypedValue) => coerceToPrimitive(typedValue),
    },
    {
      name: 'value_if_false',
      // TODO: make this withErrorsAllowed(ArgType.singularValue)
      type: withErrorsAllowed(ArgType.any),
      description: 'The value the function returns if logical_expression is FALSE.',
      // Do not coerce numeric-like arguments to numbers
      coerce: (typedValue: TypedValue) => coerceToPrimitive(typedValue),
    },
  ],
  eval: (logicalTest: boolean, valueIfTrue, valueIfFalse): EvaluablePrimitive => {
    const value = logicalTest ? valueIfTrue : valueIfFalse;
    if (value instanceof util.CellError) {
      throw value;
    }
    if (Array.isArray(value)) {
      logging.warn('Unexpected array input to IF function', {
        extra: {value},
        fingerprint: ['benchling', 'data-input', 'excess', 'if', 'unexpected-array-input'],
      });
    }
    // TODO(BNCH-114120): This assertion is incorrect, since it CAN return a range.
    // Remove this assertion once we enforce that valueIfTrue and valueIfFalse are singular values.
    return value as Exclude<typeof value, Range<EvaluablePrimitive>>;
  },
} satisfies EvaluablePrimitiveSpreadsheetFunction;
